import type { ReactNode } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { HISTORY_PATH, PROJECT_LIST_PATH, UPCOMING_PATH } from '@/features/event-discovery/paths';

const VIEWS: Readonly<Record<string, string>> = {
  upcoming: UPCOMING_PATH,
  history: HISTORY_PATH,
};

export function MovedEventDiscovery({ children }: { readonly children: ReactNode }) {
  const [params] = useSearchParams();
  if (params.get('tab') !== 'events') return <>{children}</>;
  return <Navigate to={VIEWS[params.get('view') ?? ''] ?? PROJECT_LIST_PATH} replace />;
}
